<template>
    <CieloLayout>
        <router-view v-if="!loading" />

        <div class="row" v-if="loading">
            <MoonLoader color="#00AEEF" size="70px" class="loader mx-auto mt-5 mb-4" />
        </div>
    </CieloLayout>
</template>

<script>
    import loader from '@/helpers/loader';
    import MoonLoader from 'vue-spinner/src/MoonLoader';
    import CieloLayout from '../../components/layout/CieloLayout.vue';

    export default {
        components: {
            MoonLoader,
            CieloLayout,
        },

        async created() {
            loader.multiLanguage = this.$ml;
            this.loading = true;
            if (this.hasCards) {
                this.$store.dispatch('pipeline/pushTo', 'CardListC2P');
            } else if (this.consumerPresent) {
                this.$store.dispatch('pipeline/pushTo', 'UnifiedCardPaymentC2P');
            }
            this.loading = false;
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            hasCards() {
                const cards = this.$store.state.clickToPayPayment.cards;
                return cards !== null && cards.length > 0;
            },
            consumerPresent() {
                return this.$store.state.clickToPayPayment.consumerPresent;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .loader {
        display: block;
        width: 70px;
        height: 70px;
    }
</style>
